<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="shipping_address_default()"
            :filters-default="{
                type: '',
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'type',
                    title: 'タイプ',
                    options: [
                        { text: '全て', value: '' },
                        { text: '発送人', value: 'from' },
                        { text: '受取人', value: 'to' },
                        { text: '輸入者', value: 'importer' },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        {
                            text: '▲ 名前',
                            value: 'name',
                        },
                        { text: '▼ 名前', value: '-name' },
                    ],
                },
            ]"
            filters-q-placeholder="名前、TEL、メールアドレス"
            form-modal-id="shipping_address"
            search-action="shipping_address/index"
            item-id="id"
            @after-save="onAfterSave"
            >
            <template v-slot:form="{ form, init }">
                <ShippingAddress :model="form" :init="init"></ShippingAddress>
            </template>

            <template v-slot:column="{ item }">
                <b-col md="6" class="align-self-center">
                    <p class="mb-1">
                        <b-badge
                            :variant="$store.getters['shipping_address/type2variant'](item.type)"
                            >
                            {{
                            trans.labels[
                            'shipping_addresses.type.' + item.type
                            ]
                            }}
                        </b-badge>
                        <span v-if="item.is_default">
                            ※初期値
                        </span>
                    </p>
    
                    <p v-if="item.name">
                        {{ item.name }}
                    </p>
                </b-col>
    
                <b-col md="6" class="align-self-center">
                    <div v-if="item.representative">
                        {{ item.representative }}
                    </div>
                    <div v-if="item.tel">
                        <i class="far fa-fw fa-envelope"></i>
                        <b-link :href="'tel:' + item.tel">{{ item.tel }}</b-link>
                    </div>
                    <div v-if="item.email">
                        <i class="far fa-fw fa-envelope"></i>
                        <b-link :href="'mailto:' + item.email">{{ item.email }}</b-link>
                    </div>
                </b-col>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import ShippingAddress from '@/components/ShippingAddress.vue'

export default {
    components: {
        GridPage,
        ShippingAddress,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'trans',
            'shipping_address_default',
        ])
    },
    data() {
        return {}
    },
    methods: {
        onAfterSave() {
            this.$refs.gridPage.search()
        },
    },
}
</script>

